import type { RouteRecordRaw } from 'vue-router'

import { registerHealthCheckMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

export const healthCheckRoutes: RouteRecordRaw[] = [
  {
    path: 'tools/health-checks',
    name: 'HealthChecks',
    component: () => import('./components/HealthChecksPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'configuration_control',
      navKey: 'healthChecks',
      titleKey: 'healthChecks.page.title',
      // 1.75rem is the measured live-v3 page edge; the page must not stack a second inset.
      contentInset: 'tight',
    },
    beforeEnter: () => registerHealthCheckMessages(useLocaleStore().locale),
  },
]
